<form *ngIf="configForm" [formGroup]="configForm" (ngSubmit)="onSubmit(configForm)">
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>Web Id config</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-slide-toggle formControlName="serviceEnabled">
        Web Id reminder service enabled
      </mat-slide-toggle>
      <mat-form-field>
        <input matInput placeholder="Reminder period days" required formControlName="reminderPeriodDays">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Max reminders" formControlName="maxReminders">
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Web Id transaction template" formControlName="webIdTransactionTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Web Id reminder template" formControlName="webIdReminderTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <div style="height: 20px;"></div>


      <mat-slide-toggle formControlName="smsServiceEnabled">
        Web Id SMS reminder service enabled
      </mat-slide-toggle>
      <mat-form-field>
        <input matInput placeholder="Reminder offset days" formControlName="smsReminderOffsetDays">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Reminder period days" required formControlName="smsReminderPeriodDays">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Max reminders" formControlName="smsMaxReminders">
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Web Id SMS reminder template" formControlName="webIdSmsReminderTemplateId">
          <mat-option *ngFor="let template of smsTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button type="submit" [disabled]="!configForm.valid || configForm.pristine">
        <mat-icon>done</mat-icon>
        <a>Save</a>
      </button>
    </mat-card-actions>
  </mat-card>
</form>
